/**
 * The four audiences a status' actions are split between, as `plans/P360-6305/Attention
 * Statuses.xlsx` states them. The sheet names three roles and gives everyone else a column of its
 * own, so `other` is a role here rather than an absence of one.
 */
export const ATTENTION_STATUS_ROLE_IDS = {
  pbm: 'P360PartnerManager',
  manager: 'P360SalesManager',
  geoLead: 'P360GeoLead',
  partner: 'PartnerUser',
} as const

const ROLES = ['pbm', 'manager', 'partner'] as const

export type TAttentionStatusRole = (typeof ROLES)[number] | 'other'

/** The role a `UserInfo.UserRoleId` belongs to; anything the sheet does not name is `other`. */
export const getAttentionStatusRole = (roleId: string): TAttentionStatusRole =>
  ROLES.find((role) => ATTENTION_STATUS_ROLE_IDS[role] === roleId) ?? 'other'
